import React from 'react'
import './index.scss'
import { ICONS } from '@Const/common'
import clsx from 'clsx'

interface ArrowButtonProps {
    mainColor: boolean
    type: 'left' | 'right' | 'up' | 'down'
    disabled?: boolean
    className?: string
    onClick?: () => void
}

const ArrowButton = (props: ArrowButtonProps) => {
    const getIcon = (iconType: string) => {
        switch (iconType) {
            case 'left':
                return ICONS.chevron_left
            case 'right':
                return ICONS.chevron_right
            case 'up':
                return ICONS.chevron_drop_up
            case 'down':
                return ICONS.chevron_drop_down
            default:
                break
        }
    }

    const { mainColor, disabled = false, className, onClick, type } = props

    const classNames = clsx(
        mainColor ? 'main-color-set' : 'second-color-set',
        disabled ? 'disabled' : '',
        type,
        className
    )

    return (
        <div className="arrow-button-component" data-testid="arrow-button-component">
            <button className={classNames} disabled={disabled} onClick={!disabled ? onClick : () => {}}>
                <img src={getIcon(type)} alt={type} />
            </button>
        </div>
    )
}

export default ArrowButton
